enum EntityName {
  Booking = 'BOOKING',
  BookingProjectSettings = 'BOOKING_PROJECT_SETTINGS',
  BlockedSlot = 'BLOCKED_SLOT',
  DeliveryZone = 'DELIVERY_ZONE',
  Equipment = 'EQUIPMENT'
}

export default EntityName;
